// File: src/config/Services/Userservices.js
// eslint-disable-next-line no-unused-vars
import { LOGIN_ENDPOINT, VERIFY_OTP, ALLOT_ORDER, RETURN_ORDER, RECOVER_PASS, GET_AGREEMENT, CUSTOMER_MASTER, CHANGE_PASSWORD, DAMAGE_RR, DAMAGE_SO, RECENT_DEHIRE_ORDERS, FETCH_REPORT, ALLOT_ORDER_AUTO, FETCH_SKUS, POST_TRIN, POST_TROUT, GET_BASE_DOCUMENT, GET_LOOSE_SKUS, GET_ATM_STOCKS, GET_FLOW_CUSTOMER, GET_ITEMS_DETAILS, MIS_REPORT, GET_ORDER_STATUS, GET_LAYOUT_PURCHASE, GET_STOCK_POSTING_REPORT, GET_CUSTOMER_POOL_BALANCE, GET_TRANSACTION_LAYOUTS, GET_ALL_CUSTOMERS_LIST, GET_ATM_MOVEMENTS_ORDER, RETREIVE_PASSWORD, CALENDER_VIEW, FETCH_ORDER_DETAILS, FETCH_ORDER_STATUS, REJECT_TROUT, POST_BULK_TRANSFERSOUT, POST_BULK_TRIN, POST_BULK_TRANSFERSIN, BULK_TROUT_EXCEL, TRADING_SALES_ORDER, POST_TRADING_SALES_ORDER, TRADING_FETCH_KIT, UPDATE_SO_ORDERS, CONTACT_FORM_CS, CHECK_BLACKLIST, GET_JOB_PROGRESS, SEARCH_BILLING_DOCS, DOWNLOAD_BILLING_PDF, SEND_BILLING_EMAIL, REPORT_SUBSCRIPTIONS, reportSubscriptionUrl } from '../../api/URLs';
import api, { localApi } from '../../api/api';

// ========== STREAMING FUNCTIONS (NO TIMEOUT) ==========
// These functions override the default 10-min timeout for large reports

const fetchCustomerPoolBalanceStream = (payload, onProgress) => {
  return api.post(GET_CUSTOMER_POOL_BALANCE, payload, {
    onDownloadProgress: onProgress,
    timeout: 0, // ⏳ NO timeout for streaming
  });
};

const fetchDehireReportStream = (payload, onProgress) => {
  return api.post(FETCH_REPORT, payload, {
    onDownloadProgress: onProgress,
    timeout: 0, // ⏳ NO timeout for streaming
  });
};

const fetchStockPostingStream = (payload, onProgress) => {
  return api.post(GET_STOCK_POSTING_REPORT, payload, {
    onDownloadProgress: onProgress,
    timeout: 0, // ⏳ NO timeout for streaming
  });
};

const fetchMisReportStream = (payload, onProgress) => {
  return api.post(MIS_REPORT, payload, {
    onDownloadProgress: onProgress,
    timeout: 0, // ⏳ NO timeout for streaming
  });
};

const getBaseDocumentsStream = (payload, onProgress) => {
  return api.post(GET_BASE_DOCUMENT, payload, {
    onDownloadProgress: onProgress,
    timeout: 0, // ⏳ NO timeout for streaming
  });
};

// ========== ORIGINAL FUNCTIONS (10-MIN TIMEOUT) ==========

const allotOrder = (payload) => {
  return api.post(ALLOT_ORDER, payload).then((response) => {
    return response;
  });
};

const allotOrderAuto = (payload) => {
  return api.post(ALLOT_ORDER_AUTO, payload).then((response) => {
    return response;
  })
};

const returnOrders = (payload) => {
  return api.post(RETURN_ORDER, payload).then((response) => {
    return response;
  })
};

const checkAgreement = (payload) => {
  return api.post(GET_AGREEMENT, payload).then((response) => {
    return response;
  })
};

const customerMasters = (payload) => {
  return api.post(CUSTOMER_MASTER, payload).then((response) => {
    return response;
  })
};

const recoveredPass = (data) => {
  return api.post(process.env.REACT_APP_SERVER_URL_AUTH + RECOVER_PASS, data).then((response) => {
    return response;
  })
};



const changePassword = (token, formData) => {
  return api.post(`${process.env.REACT_APP_SERVER_URL_AUTH}${CHANGE_PASSWORD}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

// New services for Damage Swap
const damageSwapReturnRequest = (payload) =>
  api.post(DAMAGE_RR, payload).then((response) => response);

const damageSwapSalesOrder = (payload) =>
  api.post(DAMAGE_SO, payload).then((response) => response);

// New service for RECENT_DEHIRE_ORDERS
const recentDehireOrders = (payload) => {
  return api.post(RECENT_DEHIRE_ORDERS, payload).then((response) => {
    return response;
  });
};

const recentAtmMovements = (payload) => {
  return api.post(GET_ATM_MOVEMENTS_ORDER, payload).then((response) => {
    return response;
  });
}

// New service for FETCH_REPORT (original with 10-min timeout)
const fetchDehireReport = (payload) => {
  return api.post(FETCH_REPORT, payload).then((response) => {
    return response;
  });
};

const fetchStockPosting = (payload) => {
  return api.post(GET_STOCK_POSTING_REPORT, payload).then((response) => {
    return response;
  })
}

const fetchCustomerPoolBalance = (payload) => {
  return api.post(GET_CUSTOMER_POOL_BALANCE, payload).then((response) => {
    return response;
  })
}

const fetchSkus = (payload) => {
  return api.post(FETCH_SKUS, payload).then((response) => {
    return response;
  });
}

const fetchLooseSkus = (payload) => {
  return api.post(GET_LOOSE_SKUS, payload).then((response) => {
    return response;
  })
}

const fetchMisReport = (payload) => {
  return api.post(MIS_REPORT, payload).then((response) => {
    return response;
  })
}

const postTrout = (payload) => {
  return api.post(POST_TROUT, payload).then((response) => {
    return response;
  })
}

const postTrin = (payload) => {
  return api.post(POST_TRIN, payload).then((response) => {
    return response;
  })
}

const getBaseDocuments = (payload) => {
  return api.post(GET_BASE_DOCUMENT, payload).then((response) => {
    return response;
  })
}

const getAtmStocks = (payload) => {
  return api.post(GET_ATM_STOCKS, payload).then((response) => {
    return response;
  })
}

const getFlowToCustomer = (payload) => {
  return api.post(GET_FLOW_CUSTOMER, payload).then((response) => {
    return response;
  })
}

const getItemsDetail = (payload) => {
  return api.post(GET_ITEMS_DETAILS, payload).then((response) => {
    return response;
  })
}

const PostBulkTransfersOut = (payload) => {
  return api.post(POST_BULK_TRANSFERSOUT, payload).then((response) => {
    return response;
  })
}

const PostBulkTransfersIn = (payload) => {
  return api.post(POST_BULK_TRANSFERSIN, payload).then((response) => {
    return response;
  })
}

const fetchPurchaseLayout = (payload) => {
  return api.post(GET_LAYOUT_PURCHASE, payload).then((response) => {
    return response;
  })
}

const gettransactionlyts = (payload) => {
  return api.post(GET_TRANSACTION_LAYOUTS, payload).then((response) => {
    return response;
  })
}

const getCalenderView = (payload) => {
  return api.post(CALENDER_VIEW, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      throw error;
    });
};

const fetchOrderDetails = (payload) => {
  return api.post(FETCH_ORDER_DETAILS, payload).then((response) => {
    return response;
  });
};

const fetchOrderStatus = (payload) => {
  return api.post(FETCH_ORDER_STATUS, payload).then((response) => {
    return response;
  });
};

// Service for GET_ALL_CUSTOMERS_LIST (routed via customer-service-api)
const getAllCustomersList = (payload) => {
  return api
    .post(GET_ALL_CUSTOMERS_LIST, payload)
    .then((response) => {
      return response;
    });
};


const rejectPendingTrouts = (payload) => {
  return api.post(REJECT_TROUT, payload).then((response) => {
    return response;
  })
}

const postTrinDiffQty = (payload) => {
  return api.post(POST_BULK_TRIN, payload).then((response) => {
    return response;
  })
}

const downloadBulkTroutExcel = (payload) => {
  return api.post(BULK_TROUT_EXCEL, payload).then((response) => {
    return response;
  });
}

const fetchTradingSalesOrder = (payload) => {
  return api.post(TRADING_SALES_ORDER, payload).then((response) => {
    return response;
  });
}

const fetchTradingKitComponents = (payload) => {
  return api.post(TRADING_FETCH_KIT, payload).then((response) => {
    return response;
  });
};

const postTradingSalesOrder = (payload) => {
  return api.post(POST_TRADING_SALES_ORDER, payload).then((response) => {
    return response;
  });
}

const getOrders = (payload) => {
  return api.post(RECENT_DEHIRE_ORDERS, payload);
}

const updateSoOrder = (payload) => {
  return api.post(UPDATE_SO_ORDERS, payload).then((response) => {
    return response;
  });
}

const ticketCsForm = (payload) => {
  return api.post(CONTACT_FORM_CS, payload).then((response) => {
    return response;
  });
}

const checkBlacklist = (payload) => {
  return api.post(CHECK_BLACKLIST, payload).then((response) => {
    return response;
  });
}

const fetchJobProgress = (jobId) => {
  return api.get(`${GET_JOB_PROGRESS}/${jobId}/progress`).then((response) => {
    return response;
  });
}

const searchBillingDocs = (payload) => {
  return localApi.post(process.env.REACT_APP_SERVER_URL_ODATA_TUNNEL + SEARCH_BILLING_DOCS, payload).then((response) => {
    return response.data;
  });
}

const parseContentDispositionFilename = (header) => {
  if (!header || typeof header !== 'string') return null;
  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      return utf8Match[1].trim();
    }
  }
  const quoted = header.match(/filename="([^"]+)"/i);
  if (quoted?.[1]) return quoted[1];
  const plain = header.match(/filename=([^;]+)/i);
  return plain?.[1]?.trim() || null;
};

/**
 * Fetches merged invoice PDF (application/pdf) from ODATA backend.
 * Returns { blob, filename, annexureMerged, annexureError } or legacy JSON shape for older APIs.
 */
const parseBlobErrorBody = async (blob) => {
  try {
    const text = await blob.text();
    const json = JSON.parse(text);
    return json.error || json.message || text;
  } catch {
    return 'Failed to load billing PDF';
  }
};

const downloadBillingPdf = async (payload) => {
  try {
    const response = await localApi.post(
      process.env.REACT_APP_SERVER_URL_ODATA_TUNNEL + DOWNLOAD_BILLING_PDF,
      payload,
      { responseType: 'blob' }
    );

    const contentType = (response.headers['content-type'] || '').toLowerCase();

    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const data = JSON.parse(text);
      return { legacy: true, data };
    }

    const annexureMerged = response.headers['x-annexure-merged'] === 'true';

    return {
      legacy: false,
      blob: response.data,
      filename:
        parseContentDispositionFilename(response.headers['content-disposition']) ||
        'invoice.pdf',
      annexureMerged,
    };
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      const detail = await parseBlobErrorBody(err.response.data);
      const annexErr = new Error(detail);
      annexErr.status = err.response?.status;
      annexErr.isAnnexureRequired = err.response?.status === 503;
      throw annexErr;
    }
    throw err;
  }
};

const sendBillingEmail = (payload) => {
  return localApi.post(process.env.REACT_APP_SERVER_URL_ODATA_TUNNEL + SEND_BILLING_EMAIL, payload).then((response) => {
    return response.data;
  });
}

const listReportSubscriptions = () => {
  return api.get(REPORT_SUBSCRIPTIONS).then((response) => response.data);
};

const createReportSubscription = (payload) => {
  return api.post(REPORT_SUBSCRIPTIONS, payload).then((response) => response.data);
};

const updateReportSubscription = (id, payload) => {
  return api.patch(reportSubscriptionUrl(id), payload).then((response) => response.data);
};

const deleteReportSubscription = (id) => {
  return api.delete(reportSubscriptionUrl(id)).then((response) => response.data);
};

// Export all functions
export {
  // Original functions (10-min timeout)

  allotOrder,
  returnOrders,
  recoveredPass,
  customerMasters,
  checkAgreement,
  changePassword,
  damageSwapReturnRequest,
  damageSwapSalesOrder,
  recentDehireOrders,
  fetchDehireReport,
  allotOrderAuto,
  fetchSkus,
  postTrout,
  postTrin,
  getBaseDocuments,
  fetchLooseSkus,
  getAtmStocks,
  getFlowToCustomer,
  getItemsDetail,
  fetchMisReport,
  fetchPurchaseLayout,
  fetchStockPosting,
  fetchCustomerPoolBalance,
  gettransactionlyts,
  PostBulkTransfersOut,
  PostBulkTransfersIn,
  getAllCustomersList,
  getOrders,
  recentAtmMovements,
  getCalenderView,
  fetchOrderDetails,
  fetchOrderStatus,
  rejectPendingTrouts,
  postTrinDiffQty,
  downloadBulkTroutExcel,
  fetchTradingSalesOrder,
  postTradingSalesOrder,
  fetchTradingKitComponents,
  updateSoOrder,
  ticketCsForm,
  checkBlacklist,
  fetchJobProgress,
  searchBillingDocs,
  downloadBillingPdf,
  sendBillingEmail,

  // Streaming versions (NO timeout)
  fetchCustomerPoolBalanceStream,
  fetchDehireReportStream,
  fetchStockPostingStream,
  fetchMisReportStream,
  getBaseDocumentsStream,
  listReportSubscriptions,
  createReportSubscription,
  updateReportSubscription,
  deleteReportSubscription,
};
